/* ==========================================================================
   Boot

   Load order matters: markets and products are data, localization needs them
   to render prices, and the cart needs localization to price its lines.
   Each page sets LUVZ.assetBase before this runs so JS-built markup can
   resolve asset paths from whatever depth the page sits at.
   ========================================================================== */

(function () {
  'use strict';

  var EXIT_DURATION = 180; // keep in sync with the transition timing in base.css

  function start() {
    LUVZ.localization.init();
    LUVZ.cart.init();
    LUVZ.ui.init();
    if (LUVZ.reviewList) LUVZ.reviewList.init();
    LUVZ.newsletterPopup.init();
    initPageTransitions();
  }

  // Pages are plain static HTML, so every internal link is a full
  // navigation. Fade/slide the current page out before following it so the
  // change reads as a transition rather than an instant swap; the incoming
  // page fades in via the `luvz-loading` class already sitting on <html>.
  function initPageTransitions() {
    document.documentElement.classList.remove('luvz-loading');
    /* no exit animation inside the theme editor or when it is switched off */
    if ((window.Shopify && Shopify.designMode) || LUVZ.pageTransitions === false) return;

    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

      var link = e.target.closest && e.target.closest('a[href]');
      if (!link || link.target === '_blank' || link.hasAttribute('download')) return;

      var url;
      try {
        url = new URL(link.href, window.location.href);
      } catch (err) {
        return;
      }

      if (url.origin !== window.location.origin) return;
      // Same-page anchors and hash links shouldn't trigger a full transition.
      if (url.pathname === window.location.pathname && url.hash) return;

      e.preventDefault();
      document.body.classList.add('luvz-leaving');
      window.setTimeout(function () {
        window.location.href = link.href;
      }, EXIT_DURATION);
    });

    window.addEventListener('pageshow', function (e) {
      if (e.persisted) {
        document.body.classList.remove('luvz-leaving');
        document.documentElement.classList.remove('luvz-loading');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
}());
